import { HeadContent, Outlet, useLoaderData } from "@tanstack/react-router";
import { useLayoutEffect } from "react";

export const RootComponent = () => {
  const loaderData = useLoaderData({ from: "__root__" });

  useLayoutEffect(() => {
    const styleElementId = "branding-stylesheet";
    const existingStyleElement = document.getElementById(styleElementId);

    if (!loaderData?.stylesheet) {
      if (existingStyleElement) {
        existingStyleElement.remove();
      }
      return;
    }

    if (existingStyleElement instanceof HTMLStyleElement) {
      if (existingStyleElement.textContent !== loaderData.stylesheet) {
        existingStyleElement.textContent = loaderData.stylesheet;
      }
      return;
    }

    const styleElement = document.createElement("style");
    styleElement.id = styleElementId;
    styleElement.textContent = loaderData.stylesheet;
    document.head.appendChild(styleElement);
  }, [loaderData?.stylesheet]);

  useLayoutEffect(() => {
    const primaryColor = loaderData?.branding?.colors?.primary;
    if (primaryColor) {
      document.documentElement.style.setProperty("--custom-login-color", primaryColor);
    } else {
      document.documentElement.style.removeProperty("--custom-login-color");
    }
  }, [loaderData?.branding?.colors?.primary]);

  return (
    <>
      <HeadContent />
      <Outlet />
    </>
  );
};
